import './index.css';
import App from './modules/components';
import { Provider } from 'react-redux';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/css/v4-shims.css';
import { createRoot } from 'react-dom/client';

// Store configuration for development and production.
const configureStore = process.env.NODE_ENV === 'production'
	? require('./stores/configureStore.prod').default
	: require('./stores/configureStore.dev').default;

const store = configureStore();

const root = createRoot(document.getElementById('root')!);
root.render(
	(
		<Provider store={store}>
			<App/>
		</Provider>
	)
);

